import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";
import { buildFormData } from "./buildFormData";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

// ✅ FIX 1: unique type string — pehle "posts/fetchPosts" tha, jo
// 'postData' thunk (PostSlice.js) ke saath SAME tha. Dono thunks same
// type string share kar rahe the, isliye Redux Toolkit ke andar
// dono slices ek doosre ke actions par bhi react kar rahe the
// (cross-slice state pollution — chahe abhi visibly issue na ho,
// ye ek silent correctness bug hai jo future mein confuse karega).
export const getData = createAsyncThunk(
  "getData/fetchData",
  async ({ url, FormDataDynamic }, { rejectWithValue }) => {
    try {
      const formData = buildFormData(FormDataDynamic);

      // ✅ No Authorization header — cookie automatically bhej deta hai withCredentials se
      const response = await axiosInstance.post(url, formData, {
        headers: {
          Accept: "*/*",
        },
      });

      return response && response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);

      // ✅ FIX 2: rejectWithValue use karo — isse rejected action ka
      // 'payload' bhi ek predictable shape mein milta hai
      // (jaise { success: false, message: "..." }), plain `undefined`
      // nahi. Isse calling code jab `data?.payload?.success` check
      // karta hai, wo safely `false` milta hai, TypeError nahi aata.
      return rejectWithValue(
        error.response?.data || { success: false, message: error.message }
      );
    }
  }
);

const getDataSlice = createSlice({
  name: "getData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(getData.rejected, (state, action) => {
        state.status = "failed";
        // action.payload ab defined rahega (rejectWithValue ki wajah se)
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default getDataSlice.reducer;